<template>
  <component :is="wrapperEl">
    <slot
      v-for="slot in slots"
      :name="slot"
    />
  </component>
</template>

<script>
export default {
  name: 'VetsterSlotWrapper',

  props: {
    slots: {
      type: Array,
      default: () => [],
    },
    wrapperEl: {
      type: String,
      default: 'div',
    },
  },
};
</script>
